exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-form .table-body[data-v-21892a14]{word-break:break-all;font-size:14px}.table-form .table-body tr[data-v-21892a14]:last-child{border:none}[data-v-21892a14] .el-card .el-card__header{padding:10px}[data-v-21892a14] .custom-card{border-bottom:none!important}[data-v-21892a14] .el-card .el-card__header{padding:0!important}", ""]);

// exports
